/**
 * Momsberegning (dansk marked, 25 %).
 *
 * Alle portalpriser er ex moms; Shopify-listepriser er inkl. moms.
 * Ren logik — ingen React, ingen Supabase, ingen I/O.
 */

export const VAT_RATE = 0.25;

function assertFinite(value: number, name: string): void {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    throw new TypeError(`${name} skal være et endeligt tal, fik: ${value}`);
  }
}

/** Konverter pris inkl. moms → ex moms (÷ 1,25). */
export function exVat(priceInclVat: number): number {
  assertFinite(priceInclVat, "priceInclVat");
  return priceInclVat / (1 + VAT_RATE);
}

/** Konverter pris ex moms → inkl. moms (× 1,25). */
export function inclVat(priceExVat: number): number {
  assertFinite(priceExVat, "priceExVat");
  return priceExVat * (1 + VAT_RATE);
}

/** Momsbeløbet af en pris ex moms (× 0,25). */
export function vatAmount(priceExVat: number): number {
  assertFinite(priceExVat, "priceExVat");
  return priceExVat * VAT_RATE;
}

/**
 * Afrund til øre-præcision (2 decimaler), "round half up" (halve rundes op
 * mod +∞, som Math.round). Flydende-komma-sikker: 1.005 → 1.01.
 */
export function roundToOre(amount: number): number {
  assertFinite(amount, "amount");
  // Skaler via streng-eksponent for at undgå binær repræsentationsfejl
  // (1.005 * 100 === 100.49999999999999).
  const scaled = Number(`${amount}e2`);
  if (!Number.isFinite(scaled)) return Math.round(amount * 100) / 100;
  return Number(`${Math.round(scaled)}e-2`);
}
